import { FailedInvite } from './FailedInvite';
import '../../styles/form/_form-inner-form.scss'; // Assuming this is a CSS import

// Vendors
import React, { useEffect, useState } from 'react';
import { Form } from 'react-redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import validator from 'validator';
import cryptoJS from 'crypto-js';

// Commons
import { formatText, FormattedText } from 'core/i18n';

// Utilities
import StringHelper from 'utilities/stringHelper';
import { recordEvent, PAGE_PRODUCT } from 'utilities/uTagging';
import {
    getReferenceOptionsDocumentTypeByCountry,
    setPlaceHolderDocTypeByCountry,
} from 'utilities/multiLanguageHelper';
import { getValidation, getLastNameValidationRegExp, getNamingValidationRegExp } from 'commonsUtilities/validations';

// Components
import { InputText } from 'components/inputText/inputText';
import { RadioButton } from 'components/RadioButton/RadioButton';
import CheckBox from 'components/checkBox/checkBox';
import SplitFields from 'components/containers/splitFields/splitFields';
import { InfoTooltip } from 'components/tooltip/tooltip';
import { SelectList } from 'components/SelectList/SelectList';

// Actions
import { actions as formActions } from 'react-redux-form';
import * as initialActions from 'actions/initialActions';
import * as optionsActions from 'actions/optionsActions';
import * as focusActions from 'actions/focusActions';
import * as jointHoldersActions from 'actions/jointHoldersActions';
import * as preLoaderActions from 'actions/preLoaderActions';
import * as jointHoldersStatusActions from 'actions/jointHoldersStatusActions';

// Constants
import { PATH_ADD_JOINHOLDER } from 'constants/uTagConstants/paths';
import { BROKER } from 'constants/products';
import { COUNTRY_DOCUMENT_TYPE_DNI } from 'constants/multiLanguage';
import { ONB_BANK_DEPOSIT_OPEN } from 'constants/onboardingTypes';

// Hooks
import { useComponentWillMount } from 'hooks/useComponentWillMount';
import { AUTHORIZED, COOWNER } from 'constants/jointHolders/holderTypes';
import { getIsCoOwner } from 'utilities/jointHolders/holderTypes';

const InnerForm = ({
    userProfile,
    formActions,
    modelProp,
    userProfileForm,
    isStandByHC,
    onCancelAction,
    id,
    joinHolderEditable,
    jointHoldersActions,
    jointHoldersStatusActions,
    handleOnAdd,
    focus,
}) => {
    const [isNameGroupValidate, setIsNameGroupValidate] = useState(true);
    const [fieldsError, setFieldsError] = useState({});
    const [oldData, setOldData] = useState({});
    const [showCheckCard, setShowCheckCard] = useState(false);
    const [showFailedInviteMessage, setShowFailedInviteMessage] = useState(false);

    const updateShowCheckCard = showCheckCard => {
        setShowCheckCard(showCheckCard);

        if (!showCheckCard) {
            formActions.change(`userProfile.${modelProp}openDebitCard`, false);
        }
    };

    useComponentWillMount(() => {
        let checkedCard;

        if (!userProfile[`${modelProp}documentType`]) {
            formActions.change(
                `userProfile.${modelProp}documentType`,
                getReferenceOptionsDocumentTypeByCountry()[0].value
            );
        }
        if (userProfile.onboardingType === ONB_BANK_DEPOSIT_OPEN) {
            formActions.change(`userProfile.${modelProp}accountType`, COOWNER);
            checkedCard = true;
        } else if (userProfile.promoCode) {
            checkedCard =
                getIsCoOwner(userProfile[`${modelProp}accountType`]) &&
                userProfile.promoCode.toUpperCase() !== 'TARJETAHOME' &&
                userProfile.promoCode.toUpperCase() !== 'TARJETASOLIDARIA';
        } else {
            checkedCard = getIsCoOwner(userProfile[`${modelProp}accountType`]);
        }

        updateShowCheckCard(checkedCard);

        setOldData({
            name: userProfile[`${modelProp}name`] ? userProfile[`${modelProp}name`] : '',
            lastName: userProfile[`${modelProp}lastName`] ? userProfile[`${modelProp}lastName`] : '',
            secondLastName: userProfile[`${modelProp}secondLastName`] ? userProfile[`${modelProp}secondLastName`] : '',
            docType: userProfile[`${modelProp}documentType`] ? userProfile[`${modelProp}documentType`] : '',
            docNumber: userProfile[`${modelProp}docNumber`] ? userProfile[`${modelProp}docNumber`] : '',
            email: userProfile[`${modelProp}email`] ? userProfile[`${modelProp}email`] : '',
            accountType: userProfile[`${modelProp}accountType`] ? userProfile[`${modelProp}accountType`] : '',
            openDebitCard: userProfile[`${modelProp}openDebitCard`] ? userProfile[`${modelProp}openDebitCard`] : false,
        });
    });

    useEffect(() => {
        setShowFailedInviteMessage(false);
    }, [userProfile[`${modelProp}docNumber`]]);

    const handleOnCancel = () => {
        formActions.change(`userProfile.${modelProp}name`, oldData.name);
        formActions.change(`userProfile.${modelProp}lastName`, oldData.lastName);
        formActions.change(`userProfile.${modelProp}secondLastName`, oldData.secondLastName);
        formActions.change(`userProfile.${modelProp}docType`, oldData.docType);
        formActions.change(`userProfile.${modelProp}docNumber`, oldData.docNumber);
        formActions.change(`userProfile.${modelProp}email`, oldData.email);
        formActions.change(`userProfile.${modelProp}accountType`, oldData.accountType);
        formActions.change(`userProfile.${modelProp}openDebitCard`, oldData.openDebitCard);
        onCancelAction();
    };

    const buildCancelButton = () => {
        return (
            <button type="button" onClick={handleOnCancel} className="form__button form__button-negativeB">
                {formatText('button-cancel')}
            </button>
        );
    };

    const buildAddOrSaveButton = () => {
        let addOrSaveButton = false;
        let buttonText;
        if (userProfile.jointHolderIsEditing) {
            userProfile.jointHolderIsEditing.forEach(val => {
                if (val === id) {
                    addOrSaveButton = true;
                }
            });
        }
        if (addOrSaveButton && isStandByHC && !joinHolderEditable) {
            buttonText = formatText('button-save');
        } else if (isStandByHC && joinHolderEditable) {
            buttonText = formatText('button-edit');
        } else {
            buttonText = formatText('button-add');
        }

        return (
            <button type="submit" className="form__button form__button-primaryB" disabled={showFailedInviteMessage}>
                {buttonText}
            </button>
        );
    };

    const updateFieldsError = (fieldName, valid) => {
        fieldsError[fieldName] = valid ? false : ' ';
        setFieldsError(fieldsError);
    };

    const validateSecondLastName = () => {
        const value = userProfile[`${modelProp}secondLastName`];
        const isEmpty = !value;

        if (userProfile[`${modelProp}documentType`] === COUNTRY_DOCUMENT_TYPE_DNI && isEmpty) {
            formActions.setValidity(`userProfile.${modelProp}secondLastName`, { required: !isEmpty });
            updateFieldsError(`userProfile.${modelProp}secondLastName`, !isEmpty);
            setIsNameGroupValidate(false);
        } else {
            setIsNameGroupValidate(true);
        }
    };

    const handleIDChange = () => {
        formActions.setValidity(`userProfile.${modelProp}documentType`, { required: true });

        if (userProfile[`${modelProp}documentType`] === COUNTRY_DOCUMENT_TYPE_DNI) {
            validateSecondLastName();
        } else {
            formActions.setValidity(`userProfile.${modelProp}secondLastName`, { required: true });
        }
    };

    const dniFormatNumber = (number, documentType) => {
        let docNumber = number;

        if (documentType === COUNTRY_DOCUMENT_TYPE_DNI) {
            const nZeros = 9 - docNumber.length;
            for (let i = 0; i < nZeros; i++) {
                docNumber = `0${docNumber}`;
            }
        }

        return docNumber;
    };

    const handleJointHolderAddFailed = () => {
        setShowFailedInviteMessage(true);
    };

    const handleOnAddJointholder = () => {
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        const accessToken = userProfile.accessToken;
        const fieldsToValidate = [
            `${modelProp}name`,
            `${modelProp}lastName`,
            `${modelProp}accountType`,
            `${modelProp}documentType`,
            `${modelProp}docNumber`,
            `${modelProp}email`,
        ];
        const fieldsToOmitValue = ['jointHolderAuthorizedList', 'jointHolderCount', 'jointHolderIsEditing'];
        let valid = true;
        if (userProfile.jointHoldersError) {
            formActions.change('userProfile.jointHoldersError', false);
        }

        if (userProfile[`${modelProp}documentType`] === COUNTRY_DOCUMENT_TYPE_DNI) {
            fieldsToValidate.push(`${modelProp}secondLastName`);
        }
        const checkFieldValidity = fieldName => {
            const isFieldEmpty = !userProfile[fieldName];
            const isFieldInvalid = !userProfileForm[fieldName]?.valid && !fieldsToOmitValue.includes(fieldName);
            if (isFieldEmpty) {
                formActions.setValidity(`userProfile.${fieldName}`, { required: false });
                if (
                    fieldName.search('name') !== -1 ||
                    fieldName.search('lastName') !== -1 ||
                    (userProfile[`${modelProp}documentType`] === COUNTRY_DOCUMENT_TYPE_DNI &&
                        fieldName.search('secondLastName') !== -1)
                ) {
                    setIsNameGroupValidate(false);
                }

                return false;
            }

            return !isFieldInvalid;
        };

        fieldsToValidate.forEach(prop => {
            if (!checkFieldValidity(prop)) valid = false;
        });
        if (valid) {
            // add or save the data and collapse the card.
            let addOrSaveButton = false;
            if (userProfile.jointHolderIsEditing) {
                userProfile.jointHolderIsEditing.forEach(val => {
                    if (val === id) {
                        addOrSaveButton = true;
                    }
                });
            }

            if (!addOrSaveButton) {
                // Add mode
                jointHoldersActions.add(
                    {
                        inviteDto: {
                            docNumber: dniFormatNumber(
                                userProfile[`${modelProp}docNumber`],
                                userProfile[`${modelProp}documentType`]
                            ),
                            docType: userProfile[`${modelProp}documentType`],
                            email: userProfile[`${modelProp}email`],
                            jointHolderType: userProfile[`${modelProp}accountType`],
                            openDebitCard: userProfile[`${modelProp}openDebitCard`],
                            lastname1: StringHelper.toFirstUppercase(userProfile[`${modelProp}lastName`]),
                            lastname2: userProfile[`${modelProp}secondLastName`]
                                ? StringHelper.toFirstUppercase(userProfile[`${modelProp}secondLastName`])
                                : '',
                            name: StringHelper.toFirstUppercase(userProfile[`${modelProp}name`]),
                        },
                    },
                    userProfile.accessToken,
                    handleOnAdd,
                    handleJointHolderAddFailed
                );

                if (isStandByHC) {
                    formActions.change('userProfile.jointHolderEditable', `standbyhc_${id}`);
                    jointHoldersStatusActions.statusHolders(accessToken);
                }
            } else {
                // Save mode
                jointHoldersActions.save(
                    {
                        newInvite: {
                            docNumber: dniFormatNumber(
                                userProfile[`${modelProp}docNumber`],
                                userProfile[`${modelProp}documentType`]
                            ),
                            docType: StringHelper.changeDocType(userProfile[`${modelProp}documentType`]),
                            email: userProfile[`${modelProp}email`],
                            jointHolderType: userProfile[`${modelProp}accountType`],
                            openDebitCard: userProfile[`${modelProp}openDebitCard`],
                            lastname1: StringHelper.toFirstUppercase(userProfile[`${modelProp}lastName`]),
                            lastname2: userProfile[`${modelProp}secondLastName`]
                                ? StringHelper.toFirstUppercase(userProfile[`${modelProp}secondLastName`])
                                : '',
                            name: StringHelper.toFirstUppercase(userProfile[`${modelProp}name`]),
                        },
                        oldInvite: {
                            docNumber: oldData.docNumber,
                            email: oldData.email,
                            jointHolderType: oldData.accountType,
                            openDebitCard: oldData.openDebitCard,
                            docType: StringHelper.changeDocType(oldData.docType),
                            lastname1: StringHelper.toFirstUppercase(oldData.lastName),
                            lastname2: StringHelper.toFirstUppercase(oldData.secondLastName),
                            name: StringHelper.toFirstUppercase(oldData.name),
                        },
                    },
                    userProfile.accessToken,
                    handleOnAdd
                );

                if (isStandByHC) {
                    formActions.change('userProfile.jointHolderEditable', `standbyhc_${id}`);
                    jointHoldersStatusActions.statusHolders(accessToken);
                }
            }

            const typeEvent = addOrSaveButton ? 'editar' : 'anadir';
            const withCard = userProfile[`${modelProp}openDebitCard`] ? ' con tarjeta' : '';
            const tagEvent = `${typeEvent} ${userProfile[`${modelProp}accountType`]}`.concat(withCard);

            recordEvent(
                PATH_ADD_JOINHOLDER,
                PAGE_PRODUCT,
                'intervinientes',
                tagEvent,
                '',
                '',
                '',
                userProfile.investmentType,
                docNumberEncrypted
            );
        }
    };

    const standbyHcSubmit = () => {
        const accessToken = userProfile.accessToken;
        let addOrSaveButton = false;

        if (userProfile.jointHolderIsEditing) {
            userProfile.jointHolderIsEditing.forEach(val => {
                if (val === id) {
                    addOrSaveButton = true;
                }
            });
        }

        if (addOrSaveButton) {
            formActions.change('userProfile.jointHolderEditable', `standbyhc_${id}`);
        } else {
            formActions.change('userProfile.jointHolderEditable', `addHolderOTP${id}`);
        }

        jointHoldersStatusActions.statusHolders(accessToken);
    };

    const validateDuplicatedDocuments = value => {
        let flag = true;
        if (userProfile.docNumber === value) {
            updateFieldsError(`${modelProp}docNumber`, false);
            flag = false;
        } else if (userProfile.jointHolderCount && userProfile.jointHolderCount.length > 0) {
            userProfile.jointHolderCount.forEach(id => {
                const jh = userProfile[`jointholder_${id}_docNumber`];
                if (modelProp !== `jointholder_${id}_`) {
                    if (jh === userProfile.docNumber || jh === value) {
                        flag = false;
                    }
                }
            });
        }

        return flag;
    };

    const validateDuplicatedEmails = value => {
        let flag = true;
        if (userProfile.email === value) {
            updateFieldsError(`${modelProp}email`, false);
            flag = false;
        } else if (userProfile.jointHolderCount && userProfile.jointHolderCount.length > 0) {
            userProfile.jointHolderCount.forEach(id => {
                const jh = userProfile[`jointholder_${id}_email`];
                if (modelProp !== `jointholder_${id}_`) {
                    if (jh === userProfile.email || jh === value) {
                        flag = false;
                    }
                }
            });
        }

        return flag;
    };

    const validateGroups = (fieldName, valid) => {
        const fields = userProfileForm;
        const value = userProfile[fieldName];
        if (
            fieldName === `${modelProp}name` ||
            fieldName === `${modelProp}lastName` ||
            fieldName === `${modelProp}secondLastName`
        ) {
            let isNameValid = fields[`${modelProp}name`] && fields[`${modelProp}name`].valid;
            if (fieldName === `${modelProp}name`) {
                isNameValid = value !== '' ? valid : false;
            }
            let isLastNameValid = fields[`${modelProp}lastName`] && fields[`${modelProp}lastName`].valid;
            if (fieldName === `${modelProp}lastName`) {
                isLastNameValid = value !== '' ? valid : false;
            }
            let isSecondLastNameValid = true;
            if (fields[`${modelProp}secondLastName`]) {
                isSecondLastNameValid =
                    fields[`${modelProp}secondLastName`] && fields[`${modelProp}secondLastName`].valid;
            }

            setIsNameGroupValidate(isNameValid && isLastNameValid && isSecondLastNameValid);
        }
    };

    const getInterventionTypeTooltipContent = () => {
        const shouldShowBrokerContent = userProfile.promoCode && userProfile.promoCode.toLowerCase() === BROKER;
        const titleClass = shouldShowBrokerContent
            ? 'inner-form__intervention-type-tooltip-subtitle'
            : 'inner-form__intervention-type-tooltip-title';

        const notDepositInfo = userProfile.onboardingType !== ONB_BANK_DEPOSIT_OPEN;

        return (
            <div className={'inner-form__intervention-type-tooltip'}>
                {shouldShowBrokerContent && (
                    <div className="inner-form__intervention-type-tooltip-title">
                        <FormattedText value="initial-jointHolderInterventionTypeTooltipStockAccount" />
                    </div>
                )}
                <div className={titleClass}>
                    <FormattedText value="initial-jointHolderInterventionTypeTooltipTitle" />
                </div>
                <FormattedText value="initial-jointHolderInterventionTypeTooltipContent" />
                {notDepositInfo && (
                    <>
                        <div className="inner-form__intervention-type-tooltip-subtitle">
                            <FormattedText value="initial-jointHolderInterventionTypeTooltipSubtitle" />
                        </div>
                        <FormattedText value="initial-jointHolderInterventionTypeTooltipSubcontent" />
                    </>
                )}
            </div>
        );
    };

    const renderCheckCard = () => {
        return (
            <div className="row form__input">
                <div className="col-sm-12">
                    <label className="check-label">{formatText('field-joinHolderAditionalCard')}</label>
                </div>
                <div className="col-sm-12">
                    <CheckBox
                        profileModel={`userProfile.${modelProp}openDebitCards`}
                        checkBoxList={[
                            {
                                label: <FormattedText value="field-joinHolderAditionalCardCheck" />,
                                model: `userProfile.${modelProp}openDebitCard`,
                            },
                        ]}
                        userProfile={userProfile}
                        userProfileForm={userProfileForm}
                        formActions={formActions}
                        remarkable={true}
                    />
                </div>
            </div>
        );
    };
    const handleOnSubmit = isStandByHC ? standbyHcSubmit : handleOnAddJointholder;
    const cancelButton =
        userProfile.jointHolderCount.length >= 1 || userProfile.status === 'waiting' ? buildCancelButton() : null;
    const notDepositInfo = userProfile.onboardingType !== ONB_BANK_DEPOSIT_OPEN;

    return (
        <div className="inner-form">
            <Form model="userProfile" onSubmit={handleOnSubmit}>
                <div className="row form__input">
                    <div className="col-lg-12">
                        <label>
                            <FormattedText value="field-joinHolderName" />
                        </label>
                    </div>
                    <div className="col-lg-12">
                        <SplitFields
                            isValid={isNameGroupValidate}
                            text={StringHelper.concatString(
                                [
                                    userProfile[`${modelProp}name`],
                                    userProfile[`${modelProp}lastName`],
                                    userProfile[`${modelProp}secondLastName`],
                                ],
                                ' '
                            )}
                            inputFocus={`${modelProp}name`}
                            userProfile={userProfile}
                            userProfileForm={userProfileForm}
                            formActions={formActions}
                        >
                            <div className="row clear-split">
                                <div className="col-sm-4 first-col md-form-group">
                                    <InputText
                                        profileModel={`userProfile.${modelProp}name`}
                                        placeholder={formatText('field-name')}
                                        type="text"
                                        name={`${modelProp}name`}
                                        validations={{
                                            required: value => value && value.length,
                                            valid: value =>
                                                validator.matches(
                                                    value,
                                                    getNamingValidationRegExp[__ORIGIN_COUNTRY__]
                                                ) &&
                                                value.length >= 2 &&
                                                value.length <= 20,
                                        }}
                                        isNotValidated={function () {
                                            validateGroups(`${modelProp}name`, false);
                                        }}
                                        isValidated={function () {
                                            validateGroups(`${modelProp}name`, true);
                                        }}
                                        messagesError={{
                                            required: formatText('validation-fieldRequired'),
                                            valid: formatText('validation-syntaxError'),
                                        }}
                                        errorClass="form__field_error name-errors"
                                        userProfileForm={userProfileForm}
                                        userProfile={userProfile}
                                        formActions={formActions}
                                    />
                                </div>
                                <div className="col-sm-4 middle-col md-form-group">
                                    <InputText
                                        profileModel={`userProfile.${modelProp}lastName`}
                                        placeholder={formatText('field-lastName')}
                                        type="text"
                                        name={`${modelProp}lastName`}
                                        defaultValue={userProfile[`${modelProp}lastName`]}
                                        validations={{
                                            required: value => value && value.length,
                                            valid: value =>
                                                validator.matches(
                                                    value,
                                                    getLastNameValidationRegExp[__ORIGIN_COUNTRY__]
                                                ) &&
                                                value.length >= 2 &&
                                                value.length <= 30,
                                        }}
                                        isNotValidated={function () {
                                            validateGroups(`${modelProp}lastName`, false);
                                        }}
                                        isValidated={function () {
                                            validateGroups(`${modelProp}lastName`, true);
                                        }}
                                        messagesError={{
                                            required: formatText('validation-fieldRequired'),
                                            valid: formatText('validation-syntaxError'),
                                        }}
                                        userProfileForm={userProfileForm}
                                        userProfile={userProfile}
                                        formActions={formActions}
                                    />
                                </div>
                                <div className="col-sm-4 last-col md-form-group">
                                    <InputText
                                        profileModel={`userProfile.${modelProp}secondLastName`}
                                        placeholder={formatText('field-secondLastName')}
                                        type="text"
                                        name={`${modelProp}secondLastName`}
                                        defaultValue={userProfile[`${modelProp}secondLastName`]}
                                        validations={{
                                            required: value => {
                                                return userProfile[`${modelProp}documentType`] ===
                                                    COUNTRY_DOCUMENT_TYPE_DNI
                                                    ? value && value.length
                                                    : true;
                                            },
                                            valid: value =>
                                                validator.matches(
                                                    value,
                                                    getLastNameValidationRegExp[__ORIGIN_COUNTRY__]
                                                ) &&
                                                value.length >= 2 &&
                                                (userProfile.documentType === COUNTRY_DOCUMENT_TYPE_DNI
                                                    ? value.length <= 26
                                                    : value.length <= 52),
                                        }}
                                        isNotValidated={function () {
                                            validateGroups(`${modelProp}secondLastName`, false);
                                        }}
                                        isValidated={function () {
                                            validateGroups(`${modelProp}secondLastName`, true);
                                        }}
                                        messagesError={{
                                            required: formatText('validation-fieldRequired'),
                                            valid: formatText('validation-syntaxError'),
                                        }}
                                        errorClass="form__field_error name-errors"
                                        userProfileForm={userProfileForm}
                                        userProfile={userProfile}
                                        formActions={formActions}
                                        maxLength={60}
                                    />
                                </div>
                            </div>
                        </SplitFields>
                    </div>
                </div>

                <div className="row md-form-group form__input inner-form__radios">
                    <div className="col-lg-12">
                        <label className="jointholder-type-label">
                            <FormattedText value="field-joinHolderRelation" />
                        </label>
                        <spam className="inner-form__radios-tooltip">
                            <InfoTooltip text={getInterventionTypeTooltipContent()} />
                        </spam>
                    </div>
                    <div className="col-sm-8 radio-list">
                        {notDepositInfo ? (
                            <RadioButton
                                profileModel={`userProfile.${modelProp}accountType`}
                                optionsList={[
                                    {
                                        label: formatText('jointHolderAccountType-jointHolder'),
                                        value: COOWNER,
                                    },
                                    {
                                        label: formatText('jointHolderAccountType-authorized'),
                                        value: AUTHORIZED,
                                    },
                                ]}
                                onChange={function (value) {
                                    let checkedCard = false;
                                    if (userProfile.promoCode) {
                                        checkedCard =
                                            getIsCoOwner(value) &&
                                            userProfile.promoCode.toUpperCase() !== 'TARJETAHOME';
                                    } else {
                                        checkedCard = getIsCoOwner(value);
                                    }
                                    updateShowCheckCard(checkedCard);
                                }}
                                userProfile={userProfile}
                                userProfileForm={userProfileForm}
                                formActions={formActions}
                            />
                        ) : (
                            <RadioButton
                                profileModel={`userProfile.${modelProp}accountType`}
                                disabled
                                optionsList={[
                                    {
                                        label: formatText('jointHolderAccountType-jointHolder'),
                                        value: COOWNER,
                                    },
                                ]}
                                userProfile={userProfile}
                                userProfileForm={userProfileForm}
                                formActions={formActions}
                            />
                        )}
                    </div>
                </div>

                <div className="row form__input">
                    <div className="col-lg-12 inner-form__word-break">
                        <label>
                            <FormattedText value="field-joinHolderDocument" />
                        </label>
                        <InfoTooltip
                            text={<FormattedText value="initial-document" />}
                            addClass="form__info-tooltip__width-dni"
                        />
                    </div>
                    <div className="col-sm-7">
                        <div className="form__group-inputs">
                            <div className="row">
                                <div className="col-xs-4 first-col form-dni-select">
                                    <SelectList
                                        value={getReferenceOptionsDocumentTypeByCountry()[0].value}
                                        autofocus={focus.get('documentType')}
                                        profileModel={`userProfile.${modelProp}documentType`}
                                        name="documentType"
                                        optionsList={getReferenceOptionsDocumentTypeByCountry()}
                                        clearable={false}
                                        placeholder=""
                                        messagesError={{ required: formatText('validation-selectDocumentType') }}
                                        required
                                        isUpdated={function () {
                                            handleIDChange();
                                            if (
                                                typeof userProfile[`${modelProp}docNumber`] !== 'undefined' &&
                                                userProfile[`${modelProp}docNumber`] !== ''
                                            ) {
                                                const profileModel = `userProfile.${modelProp}docNumber`;
                                                const validations = {
                                                    valid: value => {
                                                        const valid = getValidation(
                                                            value,
                                                            userProfile[`${modelProp}documentType`]
                                                        );

                                                        return valid.valid;
                                                    },
                                                    duplicated: value => validateDuplicatedDocuments(value),
                                                };

                                                formActions.validate(profileModel, validations);
                                            }
                                        }}
                                        userProfileForm={userProfileForm}
                                        userProfile={userProfile}
                                        formActions={formActions}
                                    />
                                </div>
                                <div className="col-xs-8 last-col">
                                    <InputText
                                        profileModel={`userProfile.${modelProp}docNumber`}
                                        placeholder={formatText(
                                            setPlaceHolderDocTypeByCountry(userProfile.documentType)
                                        )}
                                        type="text"
                                        name="innerDocNumber"
                                        id="innerDocNumber"
                                        inputClass="inner-form__dni-input"
                                        defaultValue={userProfile[`${modelProp}docNumber`]}
                                        validations={{
                                            required: value => value && value.length,
                                            valid: value => {
                                                const valid = getValidation(
                                                    value,
                                                    userProfile[`${modelProp}documentType`]
                                                );

                                                return valid.valid;
                                            },
                                            duplicated: value => validateDuplicatedDocuments(value),
                                        }}
                                        onBlur={function (value) {
                                            return value.toUpperCase();
                                        }}
                                        messagesError={{
                                            required: formatText('validation-fieldRequired'),
                                            valid: formatText('validation-syntaxErrorDocument'),
                                            duplicated: formatText('validation-jointHolderDniCompareValidation'),
                                        }}
                                        userProfileForm={userProfileForm}
                                        userProfile={userProfile}
                                        formActions={formActions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row form__input">
                    <div className="col-lg-12">
                        <label>{formatText('field-joinHolderEmail')}</label>
                    </div>
                    <div className="col-sm-7">
                        <InputText
                            profileModel={`userProfile.${modelProp}email`}
                            type="email"
                            id="email"
                            inputClass="inner-form__email-input"
                            name="email"
                            defaultValue={userProfile[`${modelProp}email`]}
                            validations={{
                                required: value => {
                                    return value && value.length;
                                },
                                valid: value => {
                                    return validator.isEmail(value);
                                },
                                duplicated: value => validateDuplicatedEmails(value),
                            }}
                            messagesError={{
                                required: formatText('validation-fieldRequired'),
                                valid: formatText('validation-email'),
                                duplicated: formatText('validation-jointHolderEmailCompareValidation'),
                            }}
                            userProfileForm={userProfileForm}
                            userProfile={userProfile}
                            formActions={formActions}
                        />
                    </div>
                </div>

                {showCheckCard && renderCheckCard()}
                {showFailedInviteMessage && <FailedInvite />}

                <div className="inner-form__footer">
                    <hr className="no-mrg-top" />
                    <div className={`inner-form__footer--error ${!userProfile.jointHoldersError ? 'hidden' : ''}`}>
                        <i className="icons icons--icon-warning-2-red"></i>
                        <span>{formatText('field-jointHolderError')}</span>
                    </div>
                    <div className="inner-form__footer--buttons">
                        {cancelButton}
                        {buildAddOrSaveButton()}
                    </div>
                </div>
            </Form>
        </div>
    );
};

module.exports.InnerForm = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        immStepsState: state.steps,
        focus: state.focus,
    }),
    dispatch => ({
        actions: bindActionCreators(initialActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        optionsActions: bindActionCreators(optionsActions, dispatch),
        focusActions: bindActionCreators(focusActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        jointHoldersActions: bindActionCreators(jointHoldersActions, dispatch),
        jointHoldersStatusActions: bindActionCreators(jointHoldersStatusActions, dispatch),
    })
)(InnerForm);
